// mutations
const INVENTORY_PRODUCTS_SUBCATEGORIES_ALL = (state, inventoryProductsSubCategories) => {
  if (inventoryProductsSubCategories.code === 1) {
    state.inventoryProductsSubCategories = inventoryProductsSubCategories.data
    state.status = 'success'
  } else {
    alert(inventoryProductsSubCategories.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_SUBCATEGORIES_FORM = (state, inventoryProductsSubCategories) => {
  if (inventoryProductsSubCategories.code === 1) {
    state.inventoryProductsSubCategories = inventoryProductsSubCategories.data
    state.status = 'success'
  } else {
    alert(inventoryProductsSubCategories.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_SUBCATEGORIES_SHOW = (state, inventoryProductsSubCategories) => {
  if (inventoryProductsSubCategories.code === 1) {
    state.inventoryProductsSubCategories = inventoryProductsSubCategories.data
    state.status = 'success'
  } else {
    alert(inventoryProductsSubCategories.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_SUBCATEGORIES_CREATE = (state, inventoryProductsSubCategories) => {
  if (inventoryProductsSubCategories.code === 1) {
    state.inventoryProductsSubCategories = inventoryProductsSubCategories.data
    state.status = 'success'
    alert(inventoryProductsSubCategories.message)
  } else {
    alert(inventoryProductsSubCategories.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_SUBCATEGORIES_UPDATE = (state, inventoryProductsSubCategories) => {
  if (inventoryProductsSubCategories.code === 1) {
    state.inventoryProductsSubCategories = inventoryProductsSubCategories.data
    state.status = 'success'
    alert(inventoryProductsSubCategories.message)
  } else {
    alert(inventoryProductsSubCategories.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_SUBCATEGORIES_DELETE = (state, inventoryProductsSubCategories) => {
  if (inventoryProductsSubCategories.code === 1) {
    state.inventoryProductsSubCategories = inventoryProductsSubCategories.data
    state.status = 'success'
    alert(inventoryProductsSubCategories.message)
  } else {
    alert(inventoryProductsSubCategories.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_SUBCATEGORIES = (state, inventoryProductsSubCategories) => {
  if (inventoryProductsSubCategories.code === 1) {
    state.inventoryProductsSubCategories = inventoryProductsSubCategories.data
    state.status = 'success'
    // alert(inventoryProductsSubCategories.message)
  } else {
    alert(inventoryProductsSubCategories.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_FILTER_SUBCATEGORIES = (state, inventoryProductsSubCategories) => {
  if (inventoryProductsSubCategories.code === 1) {
    state.inventoryProductsSubCategories = inventoryProductsSubCategories.data
    state.status = 'success'
    // alert(inventoryProductsSubCategories.message)
  } else {
    alert(inventoryProductsSubCategories.message)
    state.status = 'error'
  }
}

export default {
  INVENTORY_PRODUCTS_SUBCATEGORIES_ALL,
  INVENTORY_PRODUCTS_SUBCATEGORIES_FORM,
  INVENTORY_PRODUCTS_SUBCATEGORIES_SHOW,
  INVENTORY_PRODUCTS_SUBCATEGORIES_CREATE,
  INVENTORY_PRODUCTS_SUBCATEGORIES_UPDATE,
  INVENTORY_PRODUCTS_SUBCATEGORIES_DELETE,
  INVENTORY_PRODUCTS_SUBCATEGORIES,
  INVENTORY_PRODUCTS_FILTER_SUBCATEGORIES
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory/products/subcategories/mutations.js